var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isPFTT)?_c('div',{attrs:{"id":"trainBanner"}},[_c('div',{staticClass:"banner",style:({ backgroundImage: _setup.bannerStyle })})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }